
import React from 'react';
import { Popover } from 'react-bootstrap';
import { PopoverProps } from './Popover.types';
import { getClassName } from '../../helpers/common.helpers';
import "./PopoverComponent.scss";

const PopoverComponent = ({ popoverId, popoverTitle, popoverContent, popoverClass = "", popoverTitleClass = "", popoverContentClass = "" }: PopoverProps) => {

  return (
    <Popover id={popoverId} className={getClassName("popover-elem", popoverClass)}>
      {popoverTitle && <Popover.Title as="h3" className={getClassName("popover-title", popoverTitleClass)}>{popoverTitle}</Popover.Title>}
      <Popover.Content className={getClassName("popover-content", popoverContentClass)}>
        {popoverContent}
      </Popover.Content>
    </Popover>
  )
};


export default PopoverComponent;
